import { cn } from '@vgw/tailwind-merger'
import { PropsWithChildren } from 'react'

type LayoutProps = {
  className?: string
} & PropsWithChildren

export const Layout = ({ children, className }: LayoutProps) => {
  return (
    <div
      className={cn(
        'flex min-h-dvh w-full flex-col items-center bg-surface-secondary',
        className,
      )}
      data-testid="root-layout"
    >
      {children}
    </div>
  )
}
